"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cleanups = void 0;
/**
 * Track cleanup functions to run.
 *
 * Future work: deal with cleanups that return promises (that fail).
 */
class Cleanups {
    constructor() {
        this.callbacks = [];
    }
    push(cb) {
        if (typeof cb === 'function') {
            this.callbacks.push(cb);
        }
        else {
            cb.callbacks.forEach(otherCb => {
                this.callbacks.push(otherCb);
            });
        }
        return this;
    }
    run(ctx, logPrefix) {
        this.callbacks.reduceRight((_acc, cl) => {
            try {
                ctx.log(logPrefix, 'cleanup', cl.toString());
                cl();
            }
            catch (err) {
                ctx.log(logPrefix, 'cleanup', cl.toString(), 'ignored error:', err);
            }
            return null;
        }, null);
    }
}
exports.Cleanups = Cleanups;
//# sourceMappingURL=Cleanups.js.map